// 多小区配置（地图 + 业务数据 + 车辆/人员分布）

export const COMMUNITIES = {
  '青云锦绣小区': {
    name: '青云锦绣小区',
    boundary: [
      { longitude: 114.010, latitude: 32.970 },
      { longitude: 114.020, latitude: 32.970 },
      { longitude: 114.020, latitude: 32.980 },
      { longitude: 114.010, latitude: 32.980 },
      { longitude: 114.010, latitude: 32.970 }
    ],
    keyAreas: [
      {
        name: '重点区域1',
        coordinates: [
          { longitude: 114.013, latitude: 32.973 },
          { longitude: 114.017, latitude: 32.973 },
          { longitude: 114.017, latitude: 32.977 },
          { longitude: 114.013, latitude: 32.977 },
          { longitude: 114.013, latitude: 32.973 }
        ]
      }
    ],
    label: { name: '青云锦绣小区', longitude: 114.015, latitude: 32.975, offsetX: 0, offsetY: -50 },
    view: { longitude: 114.015, latitude: 32.975, height: 1500, heading: 0, pitch: -60, roll: 0 },
    devices: [
      { lon: 114.013, lat: 32.974, type: 'video' },
      { lon: 114.014, lat: 32.975, type: 'access' },
      { lon: 114.016, lat: 32.976, type: 'key-location' }
    ],
    buildings: [
      { lon: 114.0134, lat: 32.9738, name: 'A1号楼' },
      { lon: 114.0146, lat: 32.9747, name: 'A2号楼' },
      { lon: 114.0159, lat: 32.9756, name: 'A3号楼' },
      { lon: 114.0172, lat: 32.9764, name: 'A4号楼' }
    ],
    vehicles: [
      { lon: 114.014, lat: 32.972, plate: '豫Q12345', status: 'parked' },
      { lon: 114.016, lat: 32.974, plate: '豫Q67890', status: 'moving' }
    ],
    persons: [
      { lon: 114.014, lat: 32.974, name: '居民H', type: 'resident' },
      { lon: 114.016, lat: 32.977, name: '访客J', type: 'visitor' }
    ],
    data: {
      overview: [
        { icon: '🏢', value: '0', label: '楼栋数量', field: 'floorCount' },
        { icon: '🏘️', value: '0', label: '房屋数量', field: 'roomCount' },
        { icon: '👥', value: '0', label: '人口数量', field: 'populationCount' },
        { icon: '🚗', value: '0', label: '车辆数量', field: 'parkingSpaceCount' },
        { icon: '📱', value: '0', label: '设备数量', field: 'deviceCount' }
      ],
      population: [
        { label: '业主数量', value: 0, field: 'ownerCount' },
        { label: '租客数量', value: 0, field: 'tenantCount' },
        { label: '男生数量', value: 0, field: 'maleCount' },
        { label: '女生数量', value: 0, field: 'femaleCount' }
      ],
      vehicleStats: [
        { label: '昨日车流量', value: 0, field: 'yesterdayTrafficFlow' },
        { label: '频繁出没车辆', value: 0, field: 'frequentVehiclesCount' },
        { label: '今日0-6时频繁出入', value: 0, field: 'todayEarlyMorningTraffic' }
      ],
      houseStats: [
        { label: '自住房屋', value: 0, field: 'ownerOccupiedCount' },
        { label: '租住房屋', value: 0, field: 'tenantOccupiedCount' }
      ],
      mapStats: [
        { label: '告警事件数量', value: 456, percentage: 70, field: 'alarmEventCount' },
        { label: '告警工单数量', value: 1023, percentage: 85, field: 'alarmWorkOrderCount' },
        { label: '重点关注人员', value: 892, percentage: 75, field: 'keyPersonnelCount' },
        { label: '社区进行活动', value: 823, percentage: 68, field: 'communityActivityCount' }
      ],
      entryStats: [
        { label: '人员进出', current: 67, total: 300, unit: '', field: 'personEntry', fieldTotal: 'personEntryTotal' },
        { label: '车辆进出', current: 54, total: 300, unit: '', field: 'vehicleEntry', fieldTotal: 'vehicleEntryTotal' },
        { label: '车位监控', current: 189, total: 500, unit: '个', field: 'parkingSpaceMonitor', fieldTotal: 'parkingSpaceMonitorTotal' },
        { label: '设备监控', current: 108, total: 250, unit: '台', field: 'deviceMonitor', fieldTotal: 'deviceMonitorTotal' }
      ],
      alarm: { count: 456, list: [{ type: '陌生人告警:', count: 156 }] },
      epidemic: undefined,
      environment: {
        metrics: [
          { label: '风速', value: '0', unit: 'm/s', field: 'windSpeed', color: 'windSpeed' }, // 浮点型，0～75
          { label: '风向', value: '0', unit: '°', field: 'windDir', color: 'windDir' }, // 整型，0～360
          { label: '大气温度', value: '0', unit: '℃', field: 'atmTemp', color: 'atmTemp' }, // 浮点型，-40～80
          { label: '大气湿度', value: '0', unit: '%RH', field: 'atmHum', color: 'atmHum' }, // 浮点型，0～100
          { label: '大气压力', value: '0', unit: 'hPa', field: 'atmPress', color: 'atmPress' }, // 浮点型，500～1100
          { label: 'PM2.5浓度', value: '0', unit: 'μg/m³', field: 'pm25', color: 'pm25' }, // 整型，0～1000
          { label: 'PM10浓度', value: '0', unit: 'μg/m³', field: 'pm10', color: 'pm10' }, // 整型，0～1000
          { label: '光照度', value: '0', unit: 'Lux', field: 'illumination', color: 'illumination' }, // 整型，0～200000
          { label: '环境噪声', value: '0', unit: 'dB', field: 'noise', color: 'noise' } // 浮点型，30～120
        ],
        pm25Trend: {
          hours: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          series: [
            {
              name: '风速',
              unit: 'm/s',
              field: 'windSpeed',
              data: [],
              min: 0,
              max: 75
            },
            {
              name: '风向',
              unit: '°',
              field: 'windDir',
              data: [],
              min: 0,
              max: 360
            },
            {
              name: '大气温度',
              unit: '℃',
              field: 'atmTemp',
              data: [],
              min: -40,
              max: 80
            },
            {
              name: '大气湿度',
              unit: '%RH',
              field: 'atmHum',
              data: [],
              min: 0,
              max: 100
            },
            {
              name: '大气压力',
              unit: 'hPa',
              field: 'atmPress',
              data: [],
              min: 500,
              max: 1100
            },
            {
              name: 'PM2.5浓度',
              unit: 'μg/m³',
              field: 'pm25',
              data: [],
              min: 0,
              max: 1000
            },
            {
              name: 'PM10浓度',
              unit: 'μg/m³',
              field: 'pm10',
              data: [],
              min: 0,
              max: 1000
            },
            {
              name: '光照度',
              unit: 'Lux',
              field: 'illumination',
              data: [],
              min: 0,
              max: 200000
            },
            {
              name: '环境噪声',
              unit: 'dB',
              field: 'noise',
              data: [],
              min: 30,
              max: 120
            }
          ]
        }
      },
      waterQuality: {
        metrics: [
          { label: 'PH值', value: '0', unit: 'pH', field: 'pH', min: 0, max: 14 },
          { label: '浊度', value: '0', unit: 'NTU', field: 'turbidity', min: 0, max: 100 },
          { label: '余氯', value: '0', unit: 'mg/L', field: 'chlorine', min: 0, max: 10 },
          { label: '电导率', value: '0', unit: 'µS/cm', field: 'conductivity', min: 0, max: 10000 },
          { label: '氨氮', value: '0', unit: 'mg/L', field: 'ammoniaNitrogen', min: 0, max: 50 },
          { label: '氟离子', value: '0', unit: 'mg/L', field: 'fluoride', min: 0, max: 10 },
          { label: '色度', value: '0', unit: '度', field: 'color', min: 0, max: 500 },
          { label: '温度', value: '0', unit: '°C', field: 'temperature', min: -40, max: 100 }
        ],
        trend: {
          hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          series: [
            { name: 'PH值', unit: 'pH', field: 'pH', data: [], min: 0, max: 14 },
            { name: '浊度', unit: 'NTU', field: 'turbidity', data: [], min: 0, max: 100 },
            { name: '余氯', unit: 'mg/L', field: 'chlorine', data: [], min: 0, max: 10 },
            { name: '电导率', unit: 'µS/cm', field: 'conductivity', data: [], min: 0, max: 10000 },
            { name: '氨氮', unit: 'mg/L', field: 'ammoniaNitrogen', data: [], min: 0, max: 50 },
            { name: '氟离子', unit: 'mg/L', field: 'fluoride', data: [], min: 0, max: 10 },
            { name: '色度', unit: '度', field: 'color', data: [], min: 0, max: 500 },
            { name: '温度', unit: '°C', field: 'temperature', data: [], min: -40, max: 100 }
          ]
        }
      },
      lightingPole: {
        metrics: [
          { label: '调光亮度', value: '0', unit: '', field: 'dimmingBrightness', min: 0, max: 100 },
          { label: '灯体开关', value: '-', unit: '', field: 'lightSwitch', min: 0, max: 1 }
        ],
        trend: {
          hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          series: [
            { name: '调光亮度', unit: '', field: 'dimmingBrightness', data: [], min: 0, max: 100 }
          ]
        }
      },
      watch: {
        metrics: [
          { label: '电量', value: '0', unit: '%', field: 'batteryLevel', min: 0, max: 100 },
          { label: '纬度', value: '0', unit: '', field: 'latitude', min: 0, max: 0 },
          { label: '经度', value: '0', unit: '', field: 'longitude', min: 0, max: 0 },
          { label: '定位时间', value: '0', unit: '', field: 'locationTime', min: 0, max: 0 },
          { label: '步数', value: '0', unit: '步', field: 'steps', min: 0, max: 50000 },
          { label: '血氧', value: '0', unit: '%', field: 'bloodOxygen', min: 0, max: 100 },
          { label: '低压', value: '0', unit: 'mmHg', field: 'lowPressure', min: 0, max: 140 },
          { label: '高压', value: '0', unit: 'mmHg', field: 'highPressure', min: 0, max: 140 },
          { label: '心率', value: '0', unit: 'bpm', field: 'heartRate', min: 0, max: 220 }
        ],
        trend: {
          hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          series: [
            { name: '电量', unit: '%', field: 'batteryLevel', data: [], min: 0, max: 100 },
            { name: '步数', unit: '步', field: 'steps', data: [], min: 0, max: 50000 },
            { name: '血氧', unit: '%', field: 'bloodOxygen', data: [], min: 0, max: 100 },
            { name: '低压', unit: 'mmHg', field: 'lowPressure', data: [], min: 0, max: 140 },
            { name: '高压', unit: 'mmHg', field: 'highPressure', data: [], min: 0, max: 140 },
            { name: '心率', unit: 'bpm', field: 'heartRate', data: [], min: 0, max: 220 }
          ]
        }
      },
      badge: {
        metrics: [
          { label: '电量', value: '0', unit: '%', field: 'batteryLevel', min: 0, max: 100 },
          { label: '纬度', value: '0', unit: '', field: 'latitude', min: 0, max: 0 },
          { label: '经度', value: '0', unit: '', field: 'longitude', min: 0, max: 0 },
          { label: '定位时间', value: '0', unit: '', field: 'locationTime', min: 0, max: 0 },
          { label: '步数', value: '0', unit: '步', field: 'steps', min: 0, max: 50000 }
        ],
        trend: {
          hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          series: [
            { name: '电量', unit: '%', field: 'batteryLevel', data: [], min: 0, max: 100 },
            { name: '步数', unit: '步', field: 'steps', data: [], min: 0, max: 50000 }
          ]
        }
      },
      locator: {
        metrics: [
          { label: '电量', value: '0', unit: '%', field: 'batteryLevel', min: 0, max: 100 },
          { label: '纬度', value: '0', unit: '', field: 'latitude', min: 0, max: 0 },
          { label: '经度', value: '0', unit: '', field: 'longitude', min: 0, max: 0 },
          { label: '定位时间', value: '0', unit: '', field: 'locationTime', min: 0, max: 0 },
          { label: '步数', value: '0', unit: '步', field: 'steps', min: 0, max: 50000 }
        ],
        trend: {
          hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          series: [
            { name: '电量', unit: '%', field: 'batteryLevel', data: [], min: 0, max: 100 },
            { name: '步数', unit: '步', field: 'steps', data: [], min: 0, max: 50000 }
          ]
        }
      }
    }
  }
}

export const DEFAULT_COMMUNITY = '青云锦绣小区'

export const getCommunityNames = () => Object.keys(COMMUNITIES)

export const getCommunityConfig = (name) => COMMUNITIES[name] || COMMUNITIES[DEFAULT_COMMUNITY]

